import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LocalizationModule } from '@abp/ng.core';
import { TooltipModule } from 'primeng/tooltip';
import { AgentStatusService } from 'src/core/services/agent-status/agent-status.service';

@Component({
  selector: 'app-quick-available',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LocalizationModule, TooltipModule],
  host: {
    '[style.display]': 'shouldShow() ? null : "none"',
  },
  templateUrl: './quick-available.component.html',
  styleUrls: ['./quick-available.component.scss'],
})
export class QuickAvailableComponent {
  readonly agentStatus: AgentStatusService = inject(AgentStatusService);
  readonly shouldShow = this.agentStatus.showGoAvailablePanel;

  async onQuickAvailable(): Promise<void> {
    await this.agentStatus.goAvailable();
  }
}
